// ANAとapassは同じテーブル・同じAPIを使い、reservation_typeで出し分けている。
// サブタブ名とURLパラメータ名はreservation_typeから導出する
export type ReservationType = 'ana' | 'apass';

export type BookingSubTab = 'ANA_BOOKING' | 'APASS_BOOKING';

export const subTabOf = (reservationType: ReservationType): BookingSubTab =>
  reservationType === 'apass' ? 'APASS_BOOKING' : 'ANA_BOOKING';

// ana_booking_type / apass_booking_type
export const bookingTypeParamKeyOf = (reservationType: ReservationType): string =>
  `${reservationType}_booking_type`;
